import React, { createContext, useContext, useState } from 'react';
import Loader from "components/Loader";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(undefined);

    // showLoader("Saving shipment…") — the message is optional.
    const showLoader = (msg) => {
        setMessage(typeof msg === "string" ? msg : undefined);
        setLoading(true);
    };
    const hideLoader = () => setLoading(false);

    return (
        <LoadingContext.Provider value={{ loading, showLoader, hideLoader }}>
            {/* Fixed overlay with its own backdrop — no need to fade the page. */}
            {loading && <Loader message={message} />}
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);
